import Umbrela from '../svg/umbrela'
import Person from '../svg/person'
import Chart from '../svg/chart'
import Lock from '../svg/lock'

export default function Features() {
  return (
    <div className='featContainer flex'>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Chart />
        <h3>In-depth Review</h3>
        <p>
          Always receive the true value for your vehicle by describing it using our in-depth
          workflows. Accepted by automotive professionals and consumers.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Lock fill='var(--primary-color)' />
        <h3>Safe and secure transactions</h3>
        <p>
          True peace of mind private sales. We manage the transaction so you never have to worry
          about losing your money or vehicle.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Person />
        <h3>Verified buyers and sellers</h3>
        <p>
          Users must be verified before buying or selling. Real people buying and selling real cars.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Umbrela fill='var(--primary-color)' />
        <h3>Protect your purchase</h3>
        <p>
          Buyers on privauto are protected with a 7 day no hassle return policy (some
          conditions apply).
        </p>
      </div>

      <style jsx>{`
        .featContainer {
          .feat {
            max-width: 36.3rem;

            & + .feat {
              margin: 0 0 0 6.5rem;
            }
          }

          h3 {
            margin: 2.9rem 0 0.7rem;
            text-align: center;
            font-size: 3.2rem;
            line-height: 3.6rem;
          }

          p {
            text-align: center;
            font-size: 1.8rem;
            line-height: 2.3rem;
          }

          :global(.feat svg) {
            width: 8rem;
            height: 7.4rem;
          }
        }

        @media (max-width: 1024px) {
          .featContainer {
            flex-direction: column;
            align-items: center;

            .feat {
              & + .feat {
                margin: 2.4rem 0 0;
              }
            }

            h3,
            p {
              font-size: 1.4rem;
              line-height: 1.8rem;
            }

            h3 {
              margin: 1.6rem 0 0;
            }

            :global(.feat svg) {
              width: 7.3rem;
              height: 6.7rem;
            }
          }
        }

        .feat :global(svg) {
          opacity: 0.5;
        }

        .feat p {
          opacity: 0.7;
        }
      `}</style>
    </div>
  )
}
